import DisclosureBaseController from "./disclosure_base_controller"

export default class extends DisclosureBaseController {
  static targets = ["checkbox", "panel"]

  // Hidden and disabled, as conditional-fields does: a hidden input is still
  // submitted, so a step kept the guest list it had just stopped admitting.
  toggle() {
    super.toggle()
    this.panelTarget.querySelectorAll("input, select, textarea").forEach((field) => { field.disabled = !this.open })
  }

  get open() {
    return this.checkboxTarget.checked
  }
}
